module.exports = __webpack_public_path__ + "static/media/myMaps.eac231e6.png";